<template>
    <VSelect
        ref="select"
        class="user-selector-new"
        :disabled="disabled"
        :filterable="false"
        :model-value="modelValue"
        :multiple="multiple"
        :options="userSelector.options.value"
        :placeholder="t('select-user')"
        @open="userSelector.prefetch"
        @option:selected="$emit('selected', userSelector.reduce($event))"
        @search="userSelector.searchAsync"
        @update:modelValue="
            $emit(
                'update:modelValue',
                Array.isArray($event) ? $event.map(userSelector.reduce) : userSelector.reduce($event),
            )
        "
    >
        <template v-slot:option="option">
            <div
                class="user-selector__select-option"
                :class="{
                    'user-selector__select-option--selected': contains(option),
                }"
            >
                <VUserCard tiny :user="option.label"></VUserCard>
            </div>
        </template>

        <template v-slot:selected-option="option">
            <VUserCard :tiny="tiny" :user="option.label"></VUserCard>
        </template>
    </VSelect>
</template>
<script setup lang="ts">
// Svg

// Components
import VSelect from './VSelect.vue';
import VUserCard from './VUserCard.vue';

// Other
import { onMounted, ref, defineProps, toRefs } from 'vue';
import { PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserSelector } from '@/mixins/SelectorsApi';

const { t } = useI18n();
const props = defineProps({
    modelValue: { type: Array as PropType<string[]>, default: () => [] },
    tiny: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    editable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
});
const { modelValue } = toRefs(props);
const userSelector = useUserSelector();

let selectEl = ref<HTMLElement | null>(null);

function contains(userId: string): boolean {
    return props.modelValue.findIndex((id) => id === userId) !== -1;
}

onMounted(() => {
    if (props.autofocus) {
        (selectEl.value?.querySelector('.vs__search') as HTMLInputElement | null)?.focus();
    }
});
</script>

<style lang="scss"></style>
